import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Link } from "react-router-dom";
import SuccessScoringReasonService from "../../../../Services/SuccessScoringReason.service";
import ContentLayout from "../../../Layout/ContentLayout";
import usePagedSortedTable, { TotalPageMappers, } from "../../../Hooks/usePagedSortedTable";
import BooleanDisplay from "../../../UI/BooleanDisplay/BooleanDisplay";
import { getSuccessScoringReasonDetailPath } from "./SuccessScoringReasonRoutes";
import DateService from "../../../../Services/Shared/Date.service";
const PAGE_SIZE = 50;
const SuccessScoringReasonListTable = () => {
    var _a, _b;
    const { table, dataState } = usePagedSortedTable({
        striped: true,
        hover: true,
        noDataComponent: "No success/risk reasons found",
        rowVerticalPadding: 2,
        getData: (sort, pageNumber) => {
            return SuccessScoringReasonService.search({}, {
                max: PAGE_SIZE,
                offset: pageNumber * PAGE_SIZE,
                sort: sort === null || sort === void 0 ? void 0 : sort.sort,
                order: sort === null || sort === void 0 ? void 0 : sort.order,
            });
        },
        getNumPages: (result) => TotalPageMappers.EngagePagedResult(result, PAGE_SIZE),
        columns: [
            {
                title: "Id",
                sortId: "SUCCESS_SCORING_REASON_ID",
            },
            {
                title: "Src System Id",
                sortId: "SUCCESS_SCORING_REASON_SRC_SYSTEM_ID",
            },
            {
                title: "Description",
                sortId: "SUCCESS_SCORING_REASON_DESCRIPTION",
            },
            {
                title: "Source Description",
                sortId: "SUCCESS_SCORING_REASON_SRC_DESCRIPTION",
            },
            {
                title: "Active",
                sortId: "SUCCESS_SCORING_REASON_ACTIVE",
            },
            {
                title: "Modified By",
                sortId: "SUCCESS_SCORING_REASON_MODIFIED_BY",
            },
            {
                title: "Modified Date",
                sortId: "SUCCESS_SCORING_REASON_MODIFIED_DATE",
            },
        ],
        rows: ({ data }) => data.map((successScoringReason, index) => {
            return [
                successScoringReason.id,
                _jsx(Link, { to: getSuccessScoringReasonDetailPath(successScoringReason.id), children: successScoringReason.srcSystemId }, index),
                successScoringReason.description,
                successScoringReason.srcDescription,
                _jsx(BooleanDisplay, { val: successScoringReason.active }, index),
                successScoringReason.modifiedBy.fullName,
                DateService.displayWithTime(successScoringReason.modifiedDate),
            ];
        }),
    });
    return (_jsxs(_Fragment, { children: [_jsxs("h1", { className: "mb-3", children: ["Success/Risk Reasons", " ", ((_a = dataState.data) === null || _a === void 0 ? void 0 : _a.total) ? `(${(_b = dataState.data) === null || _b === void 0 ? void 0 : _b.total})` : ""] }), _jsx("div", { className: "py-2", children: table })] }));
};
const SuccessScoringReasonList = () => {
    return (_jsx(ContentLayout, { whiteBackground: true, paddingTop: true, paddingBottom: true, className: "fullMinHeightMinusPrimaryNav", children: _jsx(SuccessScoringReasonListTable, {}) }));
};
export default SuccessScoringReasonList;
